export default "__VITE_ASSET__M2I14O8m__"